import { render } from "./foliodocumento.vue?vue&type=template&id=03e8fa57"
import script from "./foliodocumento.vue?vue&type=script&lang=js"
export * from "./foliodocumento.vue?vue&type=script&lang=js"

import "./foliodocumento.vue?vue&type=style&index=0&id=03e8fa57&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__